<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="menu-professional">
          <div class="menu-professional-header">
            <button
              class="menu-professional-header__btn"
              :class="{
                'menu-professional-header__btn--active':
                  companyFilterActive == 'work-in-company',
              }"
              @click="
                setDataDefault(['SET_COMPANY_FILTER_ACTIVE', 'work-in-company'])
              "
            >
              Atende essa empresa
            </button>
            <button
              class="menu-professional-header__btn"
              :class="{
                'menu-professional-header__btn--active':
                  companyFilterActive == 'not-work-in-company',
              }"
              @click="
                setDataDefault([
                  'SET_COMPANY_FILTER_ACTIVE',
                  'not-work-in-company',
                ])
              "
            >
              Não atende essa empresa
            </button>
          </div>
          <div class="row menu-professional__row">
            <template v-if="hasCompanyProfessionals">
              <template v-if="getProfessionalWorkOrNotWorkInCompany.length">
                <div
                  v-for="professional in getProfessionalWorkOrNotWorkInCompany"
                  :key="professional.id"
                  class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
                >
                  <CardCompanyProfessional :professional="professional" />
                </div>
              </template>
              <NotData v-else :text="'Nenhum profissional'" />
            </template>
            <NotData v-else :text="'Nenhum profissional cadastrado'" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardCompanyProfessional from "@/views/Company/components/CardCompanyProfessional";
import NotData from "@/components/notData/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Profissionais",
          routerName: "ListProfessionalsCompany",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Company", ["companyProfessionals", "companyFilterActive"]),
    hasCompanyProfessionals() {
      return (
        this.companyProfessionals &&
        Array.isArray(this.companyProfessionals) &&
        this.companyProfessionals.length > 0
      );
    },
    hasParams() {
      return this.$route.params && Object.keys(this.$route.params).length > 0;
    },
    professionalWorkInCompany() {
      return this.companyProfessionals.filter(
        (item) =>
          item?.companyHasProfessional &&
          Object.keys(item.companyHasProfessional).length > 0
      );
    },
    professionalNotWorkInCompany() {
      return this.companyProfessionals.filter(
        (item) => !item?.companyHasProfessional
      );
    },
    getProfessionalWorkOrNotWorkInCompany() {
      return this.companyFilterActive === "work-in-company"
        ? this.professionalWorkInCompany
        : this.professionalNotWorkInCompany;
    },
  },
  components: {
    Breadcrumb,
    CardCompanyProfessional,
    NotData,
  },
  methods: {
    ...mapActions("Company", ["consultCompanyProfessionals", "setDataDefault"]),
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
    },
  },
  async mounted() {
    if (this.hasParams) {
      const payload = { id: this.$route.params.id };
      await this.consultCompanyProfessionals(payload);
      this.handleDataBreadcrumb();
    }
  },
};
</script>

<style lang="scss" scoped>
.menu-professional {
  &-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      background: 0;
      border: 0;
      border-bottom: 2px solid transparent;
      font-size: 20px;
      font-family: "Font Light";
      color: var(--black);
      @media (max-width: 991px) {
        font-size: 14px;
      }
      &--active {
        font-family: "Font Semibold";
        font-size: 24px;
        border-color: var(--green);
        @media (max-width: 991px) {
          font-size: 16px;
        }
      }
    }
  }
  &__row {
    row-gap: 30px;
  }
}
</style>
